<div id="premium-card" class="container">
  <div id="invoice-details-container">
    <dxo-card [bodyHeader]="InvoiceCardHeader">
      <card-body>
        <div class="data-containter">
          <ng-container>
            <dxo-label-value [label]="invoiceLabel.invoicePeriod" [values]="[invoicePeriodString]"></dxo-label-value>
            <dxo-label-value [label]="invoiceLabel.invoiceNumber" [values]="[invoiceNumber]"></dxo-label-value>
            <dxo-label-value [label]="invoiceLabel.billGroupName" [values]="[groupName]"></dxo-label-value>
            <dxo-label-value [label]="invoiceLabel.billGroupNumber" [values]="[groupNumber]"></dxo-label-value>
            <div class="indicator-container" *ngIf="paymentStatus">
              <span class="status-indicator" [style.background-color]="statusColor"></span>
              <dxo-label-value [label]="invoiceLabel.paymentStatus" [values]="[paymentStatus]"> </dxo-label-value>
            </div>
            <div>
              <dxo-label-value
                *ngIf="invoiceAmount"
                [label]="invoiceLabel.estimatedAmount"
                [values]="[invoiceAmount]"
              ></dxo-label-value>
            </div>
          </ng-container>
          <div class="data-title"></div>
          <div class="data-value"></div>
        </div>
      </card-body>
    </dxo-card>

    <dxo-card [bodyHeader]="StatusCardHeader">
      <card-body>
        <div class="status-container">
          <ng-container>
            <div class="indicator-container">
              <span class="status-indicator" [style.background-color]="stateColor"></span>
              <dxo-label-value [label]="statusLabel.state" [values]="[statePlaceholder]"></dxo-label-value>
            </div>
            <div>
              <dxo-label-value [label]="statusLabel.submittedBy" [values]="[submittedBySA]"></dxo-label-value>
            </div>
            <dxo-label-value [label]="statusLabel.submittedDate" [values]="[submitDateSA]"></dxo-label-value>
          </ng-container>
        </div>
      </card-body>
    </dxo-card>
  </div>
  <dxo-card [bodyHeader]="PremiumCalculatorHeader">
    <div *ngIf="data$ | async as data; else isLoading">
      <dxo-accordion
        *ngFor="let unit of accordionData; index as accIndex"
        [title]="unit.title"
        [showBottomBorder]="false"
        [showContent]="unit.showContent"
        [value]="unit.subtotalUI"
        [dxoDataset]="[{ data: { e2e: 'prem-calc-accordion' } }]"
      >
        <accordion-content>
          <dxo-data-table *ngIf="unit" [headers]="unit.tableHeaders" [items]="unit.cellRows">
            <ng-template dxoHeaderKey="class"> Class </ng-template>
            <ng-template dxoKey="rateUI" let-item let-index="index">
              <span [attr.data-e2e]="'rate-value-' + index">
                {{ item.rateUI }}
              </span>
            </ng-template>
            <ng-template dxoKey="numLives" let-item let-index="index">
              <dxo-text-input
                [id]="'numLives-input-' + index"
                maxlength="6"
                [characterSet]="numericCharSet"
                [(value)]="item.numLivesStr"
                [dxoDataset]="[{ selector: 'input', data: { pii: '', e2e: 'num-lives-input-' + index } }]"
                (valueChange)="
                  onNumLivesChange({
                    event: +$event,
                    tableIndex: index,
                    accordionIndex: accIndex,
                    item: item,
                    inputType: textInputType.numLivesStr
                  })
                "
              >
              </dxo-text-input>
            </ng-template>
            <ng-template dxoKey="volume" let-item let-index="index">
              <dxo-text-input
                class="volume"
                [id]="'volume-input-' + index"
                *ngIf="item.rateBasis !== MemberMonth"
                [characterSet]="numericCharSet"
                [(value)]="item.volumeStr"
                maxlength="14"
                [dxoDataset]="[{ selector: 'input', data: { pii: '', e2e: 'volume-input-' + index } }]"
                (valueChange)="
                  onVolumeChange({
                    event: +$event,
                    tableIndex: index,
                    accordionIndex: accIndex,
                    item: item,
                    inputType: textInputType.volumeStr
                  })
                "
              >
              </dxo-text-input>
            </ng-template>
            <ng-template dxoKey="amounts" let-item let-index="index">
              <dxo-circular-loader *ngIf="item.showLoader; else elseBlock" [size]="'tiny'" [color]="'blue'">
              </dxo-circular-loader>
              <ng-template #elseBlock>
                <span [attr.data-e2e]="'amount-value-' + index">
                  {{ item.amounts | currency: 'USD' }}
                </span>
              </ng-template>
            </ng-template>
          </dxo-data-table>
        </accordion-content>
      </dxo-accordion>
      <div class="accordion-end-border"></div>
      <div class="card-footer">
        <span></span>
        <div class="total-calc">
          <dxo-label-value [label]="TotalAmountLabel" [values]="[invoiceTotal]"> </dxo-label-value>
        </div>
      </div>
    </div>
    <ng-template #isLoading>
      <div class="loader-container">
        <dxo-circular-loader [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
      </div>
    </ng-template>
    <dxo-modal *ngIf="showPermissionModal" [title]="ModalTitle">
      <modal-body>
        {{ ModalBodyError }}
        <dxo-button [text]="CloseText" (handleClick)="permissionModalClose()"></dxo-button>
      </modal-body>
    </dxo-modal>

    <dxo-modal
      *ngIf="submittedSuccess"
      title="Your premium calculation has been submitted"
      [maxWidth]="480"
      [shouldShowCloseX]="false"
    >
      <modal-body>
        <p>
          An email confirmation is on the way. To make a payment,
          <a href="javascript:void(0);" (click)="goBillingList()"> select the checkbox for the invoice to pay.</a>
        </p>
        <dxo-button [primary]="true" [text]="CloseText" (handleClick)="closeSubmittedPopup()"></dxo-button>
      </modal-body>
    </dxo-modal>

    <div class="button-div">
      <dxo-button text="Cancel" data-category="premium" data-action="Close Modal" (handleClick)="goBillingList()">
      </dxo-button>
      <dxo-button text="Submit adjustment" (handleClick)="onSubmit(hasSubmitPermissions)" [primary]="true"></dxo-button>
    </div>
  </dxo-card>
</div>
